import React from 'react'
import GeoentityBlock from './GeoentityBlock'

export default function GeoentityBlockTextList({ data: { list } }) {
  return list.map((block, idx) => <GeoentityBlock key={idx} block={block} />)
}
